import React from "react";
import { NavLink } from "react-router-dom";
import "./Menu.scss";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../store/ui-slice";

const Menu = () => {
  const menuOpened = useSelector((state) => state.ui.menuOpen);
  const dispatch = useDispatch();

  const toggleMenu = () => {
    dispatch(uiActions.toggleMenu());
  };

  return (
    <div className={`header-menu ${menuOpened ? "active" : ""}`}>
      <img
        src="https://webetst.coders.network/wp-content/uploads/2022/02/Wordpress_Blue_logo.png"
        alt="Webpigment"
      />
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-3 offset-1"}>
            <nav className={"main-menu"}>
              <ul>
                <li>
                  <NavLink onClick={toggleMenu} to={"/about"}>
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/work"}>
                    Work
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/services"}>
                    Services
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/approach"}>
                    Approach
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/blog"}>
                    Blog
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/careers"}>
                    Careers
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/contact"}>
                    Contact
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={toggleMenu} to={"/01-all-sections"}>
                    all
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
          <div className={"col-4"}>
            <div className={"get-in-touch"}>
              <h6>GET IN TOUCH</h6>
              <p>
                <a href={"#"}>+389 70 899 838</a>
              </p>
              <p>
                <a href={"#"}>hello@webpigment.com</a>
              </p>
              <p>
                <NavLink onClick={toggleMenu} to={"/careers"}>
                  Careers
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
